import { createListAction } from '../../../../EdgeControllersListPage/shared/lib/edgeListHelper';

export const getEdgeTasks = (rows) => createListAction(rows);
